import vuexLocal from "postcss";

export default {
    state: {
        countyMap: [{text: "", value: null}, 
            {text: "Napa", value: "28"},
            {text: "Lake", value: "17"},
            {text: "Marin", value: "21"},
            {text: "Mendocino", value: "23"}, 
            {text: "Sonoma", value: "49"}, 
            {text: "Solano", value: "48"}],
    },
    getters: {
        countyMap(state) {
            return state.countyMap;
        }
    },
    plugins: [vuexLocal.plugin]
}
